<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <div>
            <vs-tab
              :label="$t('DeductionAndIncreaseByGenericProduct')"
              class="mt-6"
            >
              <deduction-and-increase-by-generic-product></deduction-and-increase-by-generic-product>
            </vs-tab>
          </div>
          <div>
            <vs-tab :label="$t('DeductionAndIncreaseByProduct')" class="mt-6">
              <deduction-and-increase-by-product></deduction-and-increase-by-product>
            </vs-tab>
          </div>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import DeductionAndIncreaseByGenericProduct from "./DeductionAndIncreaseByGenericProduct/Index.vue";
import DeductionAndIncreaseByProduct from "./DeductionAndIncreaseByProduct/Index.vue";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "",

  components: {
    DeductionAndIncreaseByGenericProduct,
    DeductionAndIncreaseByProduct,
  },
};
</script>
